import React from "react";

const Spinner = () => (
  <div id="loader-wrapper">
    <div id="loader"></div>
  </div>
);
export default Spinner;
